import { Route } from '@angular/router';
import { Path } from './enums/path.enum';
import { notLoggedGuard } from './guard/not-logged.guard';
import { loggedInGuard } from './guard/logged-in.guard';
import { notMaintainanceGuard } from './guard/not-maintainance.guard';
import { maintainanceGuard } from './guard/maintainance.guard';

export const appRoutes: Route[] = [
  {
    path: Path.HOME,
    loadComponent: () =>
      import('./pages/home/home.component').then((x) => x.HomeComponent),
    children: [
      {
        path: Path.ERROR,
        loadComponent: () =>
          import('./pages/home/pages/error/error.component').then(
            (x) => x.ErrorComponent
          ),
      },
      {
        path: Path.HELP,
        loadComponent: () =>
          import('./pages/home/pages/help/help.component').then(
            (x) => x.HelpComponent
          ),
        canActivate: [maintainanceGuard],
      },
      {
        path: Path.LOGIN,
        loadComponent: () =>
          import('./pages/home/pages/login/login.component').then(
            (x) => x.LoginComponent
          ),
        canActivate: [notLoggedGuard, maintainanceGuard],
      },
      {
        path: Path.CERTIFICA_CELLULARE,
        loadComponent: () =>
          import('./pages/home/pages/certifica-cellulare/certifica-cellulare.component')
            .then(x => x.CertificaCellulareComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.CERTIFICA_EMAIL,
        loadComponent: () =>
          import('./pages/home/pages/certifica-email/certifica-email.component')
            .then(x => x.CertificaEmailComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.VERIFICA_COMPLETATA,
        loadComponent: () =>
          import('./pages/home/pages/verifica-completata/verifica-completata.component')
            .then(c => c.VerificaCompletataComponent),
            canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.LOGIN_OTP_SEND,
        loadComponent: () =>
          import('./pages/home/pages/login-otp-send/login-otp-send.component')
            .then(c => c.LoginOtpSendComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.LOGIN_OTP_VERIFY,
        loadComponent: () =>
          import('./pages/home/pages/login-otp-verify/login-otp-verify.component')
            .then(c => c.LoginOtpVerifyComponent),
        canActivate: [loggedInGuard, maintainanceGuard],
      },
      {
        path: Path.CAMBIO_PASSWORD_SCADUTA,
        loadComponent: () =>
          import('./pages/home/pages/cambio-password-scaduta/cambio-password-scaduta.component')
            .then(c => c.CambioPasswordScadutaComponent),
        canActivate: [maintainanceGuard],
      },
      {
        path: Path.RECUPERO_PASSWORD,
        loadComponent: () =>
          import(
            './pages/home/pages/retrieve-password/retrieve-password.component'
          ).then((x) => x.RetrievePasswordComponent),
        canActivate: [notLoggedGuard, maintainanceGuard],
      },
      {
        path: Path.RECUPERO_USERNAME,
        loadComponent: () =>
          import(
            './pages/home/pages/retrieve-username/retrieve-username.component'
          ).then((x) => x.RetrieveUsernameComponent),
        canActivate: [notLoggedGuard, maintainanceGuard],
      },
      {
        path: Path.TERMINI_CONDIZIONI,
        loadComponent: () =>
          import(
            './pages/home/pages/terms-conditions/terms-conditions.component'
          ).then((x) => x.TermsConditionsComponent),
        canActivate: [maintainanceGuard],
      },
      {
        path: Path.MANUTENZIONE,
        loadComponent: () =>
          import('./pages/home/pages/maintainance/maintainance.component').then(
            (x) => x.MaintainanceComponent
          ),
        canActivate: [notMaintainanceGuard],
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.ATTIVITA_CLIENTE}/${Path.CONSEGNA_CLIENTE}`,
      },
    ],
  },
  {
    path: Path.BRIDGE,
    pathMatch: 'full',
    redirectTo: `/${Path.ATTIVITA_CLIENTE}/${Path.CONSEGNA_CLIENTE}`,
  },
  {
    path: Path.ATTIVITA_CLIENTE,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: `:url`,
        loadComponent: () =>
          import('./pages/client-activities/client-activities.component').then(
            (x) => x.ClientActivitiesComponent
          ),
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.ATTIVITA_CLIENTE}/${Path.CONSEGNA_CLIENTE}`,
      },
    ],
  },
  {
    path: Path.ATTIVITA_CORRIERE,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: `:url`,
        loadComponent: () =>
          import(
            './pages/courier-activities/courier-activities.component'
          ).then((x) => x.CourierActivitiesComponent),
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.ATTIVITA_CORRIERE}/${Path.ACCETTAZIONE_CORRIERE}`,
      },
    ],
  },
  {
    path: Path.MAGAZZINO_PACCHI,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: `:url`,
        loadComponent: () =>
          import('./pages/package-warehouse/package-warehouse.component').then(
            (x) => x.PackageWarehouseComponent
          ),
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.MAGAZZINO_PACCHI}/${Path.GIACENZA}`,
      },
    ],
  },
  {
    path: Path.MAGAZZINO_MATERIALI,
    loadComponent: () =>
      import('./components/basic-page/basic-page.component').then(
        (x) => x.BasicPageComponent
      ),
    canActivate: [loggedInGuard, maintainanceGuard],
    children: [
      {
        path: ':url',
        loadComponent: () =>
          import('./pages/consumable-warehouse/consumable-warehouse.component').then(
            (x) => x.ConsumableWarehouseComponent
          ),
      },
      {
        path: Path.HOME,
        pathMatch: 'full',
        redirectTo: `/${Path.MAGAZZINO_MATERIALI}/${Path.ORDINI}`,
      },
    ],
  },
  {
    path: Path.GESTIONE_PUNTOPOSTE,
    loadComponent: () =>
      import(
        './components/basic-page-full-tab/basic-page-full-tab.component'
      ).then((x) => x.BasicPageFullTabComponent),
    children: [
      {
        path: Path.HOME,
        loadComponent: () =>
          import(
            './pages/puntoposte-management/puntoposte-management.component'
          ).then((x) => x.PuntoposteManagementComponent),
        children: [
          {
            path: Path.ANAGRAFICA,
            loadComponent: () =>
              import(
                './pages/puntoposte-management/components/registry/registry.component'
              ).then((x) => x.RegistryComponent),
          },
          {
            path: Path.CONTATTI,
            loadComponent: () =>
              import(
                './pages/puntoposte-management/components/contacts/contacts.component'
              ).then((x) => x.ContactsComponent),
          },
          {
            path: Path.ORARI_CHIUSURE,
            loadComponent: () =>
              import(
                './pages/puntoposte-management/components/opening-closures/opening-closures.component'
              ).then((x) => x.OpeningClosuresComponent),
          },
          {
            path: Path.CAMBIO_PASSWORD,
            loadComponent: () =>
              import(
                './pages/puntoposte-management/components/change-password/change-password.component'
              ).then((x) => x.ChangePasswordComponent),
          },
          {
            path: Path.HOME,
            pathMatch: 'full',
            redirectTo: `/${Path.GESTIONE_PUNTOPOSTE}/${Path.ANAGRAFICA}`,
          },
        ],
      },
    ],
    canActivate: [loggedInGuard, maintainanceGuard],
  },
  {
    path: Path.BACHECA,
    loadComponent: () =>
      import(
        './components/basic-page-full-tab/basic-page-full-tab.component'
      ).then((x) => x.BasicPageFullTabComponent),
    children: [
      {
        path: Path.HOME,
        loadComponent: () =>
      import(
        './pages/notice-board/notice-board.component'
      ).then((x) => x.NoticeBoardComponent),
      children: [
        {
          path: Path.HOME,
          loadComponent: () =>
            import('./pages/notice-board/board-list//board-list.component').then(
              (x) => x.BoardListComponent
            ),
        },
        {
          path: `${Path.DETTAGLIO_BACHECA}/:idBacheca`,
          loadComponent: () =>
            import('./pages/notice-board/board-detail/board-detail.component').then(
              (x) => x.BoardDetailComponent
            ),
        },
      ],
      },
    ],
    canActivate: [loggedInGuard, maintainanceGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/home/home.component').then((x) => x.HomeComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './pages/home/pages/page-not-found/page-not-found.component'
          ).then((x) => x.PageNotFoundComponent),
      },
    ],
  },
];
